import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi, KSeFDashboardDto } from "./ksefApi";

export const useKsefDashboard = () => {
  const { isLoading, data } = useQuery<KSeFDashboardDto>({
    queryKey: QUERIES_KEYS.KSEF_DASHBOARD(),
    queryFn: () => ksefApi.fetchDashboard().then((r) => r.data),
    refetchInterval: 30000,
  });

  return { isLoading, dashboard: data };
};
